module.exports = __webpack_public_path__ + "static/media/AsheBrewingbarmuraldetail2THUMBNAIL.be977c63.webp";